import { useApiCall } from "../../common/useApiCall"
import { changeMyProfilePicture, changePassword, createEmergencyContact, forceResetPassword, getMyProfile, login, resetPassword, updateEmergencyContact, updateMyProfile } from "../../../redux/slices/userSlice"
import { assignEmployeeToTL, fetchAllConversationUsers, fetchAllMessagesUsers, fetchAllUserConversationList, getAttendanceList, getEmployeeList, getEmployeeProfile, getUserDashboard, getUserList, getUserProfile, reopenAttendance, updateUser } from "../../../redux/slices/adminListSlice"

export const useUserApi = () => {
    const apiCall = useApiCall()

    const loginUser = (data, onSuccess, onError) => {
        apiCall(login.type, data, onSuccess, onError, false);
    }

    const resetLoginPassword = (data, onSuccess, onError) => {
        apiCall(resetPassword.type, data, onSuccess, onError, false)
    }

    const changePass = (data, onSuccess, onError) => {
        apiCall(changePassword.type, data, onSuccess, onError);
    }

    const forceResetPass = (data, onSuccess, onError) => {
        apiCall(forceResetPassword.type, data, onSuccess, onError)
    }

    const listAllUser = (data, onSuccess, onError) => {
        apiCall(getUserList.type, data, onSuccess, onError);
    }

    const fetchMyProfile = (data, onSuccess, onError) => {
        apiCall(getMyProfile.type, data, onSuccess, onError);
    }

    const fetchUserProfile = (data, onSuccess, onError) => {
        apiCall(getUserProfile.type, data, onSuccess, onError);
    }
    const fetchEmployeeProfile = (data, onSuccess, onError) => {
        apiCall(getEmployeeProfile.type, data, onSuccess, onError);
    }


    const updateUserData = (data, onSuccess, onError) => {
        apiCall(updateUser.type, data, onSuccess, onError);
    }

    const listAllEmployee = (data, onSuccess, onError) => {
        apiCall(getEmployeeList.type, data, onSuccess, onError);
    }

    const listAllAttendance = (data, onSuccess, onError) => {
        apiCall(getAttendanceList.type, data, onSuccess, onError);
    }

    const reOpenAttendance = (data, onSuccess, onError) => {
        apiCall(reopenAttendance.type, data, onSuccess, onError);
    }


    const assignEmployees = (data, onSuccess, onError) => {
        apiCall(assignEmployeeToTL.type, data, onSuccess, onError)
    }

    const listUserDashboard = (data, onSuccess, onError) => {
        apiCall(getUserDashboard.type, data, onSuccess, onError)
    }
    const updateProfilePicture = (data, onSuccess, onError) => {
        apiCall(changeMyProfilePicture.type, data, onSuccess, onError)
    }



    /********************ALl Conversations ****************** */
    const getAllRooms = (data, onSuccess, onError) => {
        apiCall(fetchAllConversationUsers.type, data, onSuccess, onError)
    }
    const getAllRoomMessages = (data, onSuccess, onError) => {
        apiCall(fetchAllMessagesUsers.type, data, onSuccess, onError)
    }



    const createEmergency = (data, onSuccess, onError) => {
        apiCall(createEmergencyContact.type, data, onSuccess, onError)
    }
    const updateEmergency = (data, onSuccess, onError) => {
        apiCall(updateEmergencyContact.type, data, onSuccess, onError)
    }
    const updateEmployeeProfile = (data, onSuccess, onError) => {
        apiCall(updateMyProfile.type, data, onSuccess, onError)
    }


    const allConversationsUsers = (data, onSuccess, onError) => {
        apiCall(fetchAllUserConversationList.type, data, onSuccess, onError)
    }


    return {
        loginUser,
        resetLoginPassword,
        changePass,
        forceResetPass,
        updateUserData,
        updateEmployeeProfile,
        listAllUser,
        listAllEmployee,
        listAllAttendance,
        reOpenAttendance,
        fetchMyProfile,
        fetchUserProfile,
        assignEmployees,
        updateProfilePicture,
        fetchEmployeeProfile,
        listUserDashboard,
        getAllRooms,
        getAllRoomMessages,
        createEmergency,
        updateEmergency,
        allConversationsUsers,
    }
}